// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeMemberGetBody = {
  poolId: string;
  targetUserId: string;
};

export type typeMemberGetOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | {
    displayName: string;
    username: string;
    avatarUrl?: string | null;
    poolRole: "owner" | "admin" | "member";
    status:
      "pending" | "active" | "suspended" | "left" | "removed" | "rejected";
    joinedAt?: string | null;
    medalsThisSeason: number | null;
    medalsAwardedThisSeason: number | null;
    medalsAllTime: number | null;
    customAwardsAllTime: number;
    trophiesAllTime: number | null;
    isPlayingNow: boolean | null;
    activeContests: { contestId: string; contestName: string }[];
    canManage: boolean;
    contestStatus:
      "in" | "eliminated" | "revived" | "notPlaying" | "unavailable";
  };
};

export type typeMemberGetOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberGetOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeMemberGetOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaMemberGetBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    targetUserId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "targetUserId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createMemberGet(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaMemberGetBody);
  }

  return async function postMemberGet(
    payload: typeMemberGetBody,
  ): Promise<typeMemberGetOutput200 | typeMemberGetOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postMemberGet" failed before calling the network. #1426333f43a6`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#1426333f43a6" },
        },
        data: null,
      } as typeMemberGetOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/member/get`,
      httpMethod: "POST",
      options,
    })) as typeMemberGetOutput200 | typeMemberGetOutput400;
  };
}
